import React, { useEffect, useState } from "react";
import SlideToggle from "react-slide-toggle";

import IconMenuList from '../../../../../img/icon-menu-list.svg';
import IconCarrot from '../../../../../img/icon-carrot-white-up.svg';
import NavRegisterButton from './navRegisterButton';

/**
 * Sticky course nav
 * @param {Object} courseDetails - Currently active course details object.
 */
function CourseAnchorNav({courseDetails}){
    // controls if nav is currently sticky or not
    const [Sticky, setSticky] = useState('');

    // on render, set listener
    useEffect(() => {
        setTimeout(() => {
            window.addEventListener("scroll", isSticky);
            window.addEventListener("scroll", navActive);
            return () => {
                window.removeEventListener("scroll", isSticky);
                window.removeEventListener("scroll", navActive);
            }
        }, 500);

        const navActive = () => {
            const mainNavLinks = document.querySelectorAll(".course-details-nav ul li a");
            const scrollTop = window.scrollY;

            //set navbav anchors acvite when scrolled to that section
            mainNavLinks.forEach(link => {
                
                let section = document.querySelector(link.hash);
                let sectionShift = section.offsetTop - 80;

                if (
                    sectionShift <= scrollTop &&
                    sectionShift + section.offsetHeight > scrollTop
                ) {
                    link.parentNode.classList.add("active");
                } else {
                    link.parentNode.classList.remove("active");
                }
            });

        };
    }, []);

    const isSticky = () => {
        /* Method that will fix header after a specific scrollable */
        const scrollTop = window.scrollY;
        const posNavBar = document.querySelector('.course-details-page').offsetTop;
        const stickyClass = scrollTop >= posNavBar ? "nav-sticky" : "";
        setSticky(stickyClass);
    };

// Component level JSX return statement ******************************************************
    return (
        <nav className={`subnav-bar course-details-nav ${Sticky}`}>
            <SlideToggle collapsed noOverflowHidden render={({ toggle, toggleState, setCollapsibleElement }) => (
                <>  <div className="mobile-nav-container">
                        <button className={`subnav-bar__toggle ${toggleState}`} onClick={toggle}>
                            <span className="menu-icon"><IconMenuList /></span>Toggle Menu <span className="carrot"><IconCarrot /></span>
                        </button>
                        <NavRegisterButton customClass={'nav-collapsed-reg-button'}/>
                    </div>
                    <div className="container" ref={setCollapsibleElement}>
                        <ul className="nav-list">
                            {courseDetails.postContent && <li><a className="nav-link" href="#overview">Course Overview</a></li>}
                            {courseDetails.objectives && <li><a className="nav-link" href="#objectives">Objectives</a></li>}
                            {courseDetails.courseSchedule && <li><a className="nav-link" href="#schedule">Schedule</a></li>}
                            {courseDetails.courseDetails && <li><a className="nav-link" href="#details">Details</a></li>}
                            {courseDetails.courseAddOns && <li><a className="nav-link" href="#add-ons">Add On Packages</a></li>}
                            {!courseDetails.onlineOnly && <li><a className="nav-link" href="#dates">Dates</a></li>}
                            <li className="mobile-only"><NavRegisterButton customClass={'nav-expanded-reg-button'}/></li>
                        </ul>
                        <NavRegisterButton customClass={'nav-desktop-register-button'}/>
                    </div>
                </>
            )} />
            
        </nav>
    )
}

export default CourseAnchorNav;